import { useFormState } from 'react-hook-form'

import Button, { Props as ButtonProps } from '@/components/ui/Button'
import { useContext } from 'react'
import { CustomContext } from './CustomProvider'

type Props = ButtonProps & {
  onlyValidWhenDirty?: boolean
}

export function Submit({
  children,
  onlyValidWhenDirty = false,
  ...rest
}: Props) {
  const { id } = useContext(CustomContext)
  const { disabled, isSubmitting, isDirty } = useFormState()

  if (disabled) return

  return (
    <Button
      type="submit"
      disabled={onlyValidWhenDirty && !isDirty}
      loading={isSubmitting}
      form={id}
      {...rest}
    >
      {children}
    </Button>
  )
}
